import dayjs from "@/lib/dayjs";

interface IValidationCl {
  countryCode: string;
  isGlobalCard: boolean;
  payment: string;
}

export function cashInValidationCl ({
  countryCode,
  isGlobalCard,
  payment,
}: IValidationCl) {
  const isClGCard = payment === 'TRANSFER' && countryCode === 'CL' && isGlobalCard;
  const time = dayjs().tz('America/Santiago');
  return isClGCard && time.hour() >= 14;
}